import { render, staticRenderFns } from "./PrimaryNavigation.vue?vue&type=template&id=96234df4&scoped=true"
import script from "./PrimaryNavigation.vue?vue&type=script&lang=js"
export * from "./PrimaryNavigation.vue?vue&type=script&lang=js"
import style0 from "./PrimaryNavigation.vue?vue&type=style&index=0&id=96234df4&prod&lang=scss&scoped=true"
import style1 from "./PrimaryNavigation.vue?vue&type=style&index=1&id=96234df4&prod&lang=css"
import style2 from "./PrimaryNavigation.vue?vue&type=style&index=2&id=96234df4&prod&lang=scss&scoped=true"
import style3 from "./PrimaryNavigation.vue?vue&type=style&index=3&id=96234df4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96234df4",
  null
  
)

export default component.exports